/* eslint-disable no-unused-vars */
import { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Each,
  Checkbox,
  CheckboxInner,
  DropDownWrapper,
  MenuItem,
  ParagraphWithTooltip,
} from 'components';
import { campaignReportsActions } from 'store/actions';
import styled, { css } from 'styled-components';
import { campaignReportsRequestTypes } from 'constants';
import { useSignal } from '@preact/signals-react';
import { ArrowDropDown } from 'assets/icons';

import * as S from './Grouping.styled';

const swappedObjTypes = Object.entries(campaignReportsRequestTypes).reduce((acc, [key, value]) => {
  acc[value] = key;
  return acc;
}, {});

export const Grouping = ({ originalTableData$, filteredData$, sortConfig$ }) => {
  const dispatch = useDispatch();

  const [isChecked, setIsChecked] = useState(false);
  const containerRef = useRef(null);
  const dropDownIsOpen1$ = useSignal(false);
  const currentRequestType = useSelector((state) => state.campaignReports.tableRequestTypes);
  const isPressedBulkBtn = useSelector((state) => state.campaignReports.isPressedBulkBtn);
  const selectedTableItems = useSelector((state) => state.campaignReports.selectedTableItems);

  const requestSort = (key) => {
    let direction = 'descending';
    if (
      sortConfig$.value &&
      sortConfig$.value.key === key &&
      sortConfig$.value.direction === 'descending'
    ) {
      direction = 'ascending';
    }
    sortConfig$.value = { key, direction };
  };

  const getClassNamesFor = (name) => {
    if (!sortConfig$.value) return;
    return sortConfig$.value.key === name ? sortConfig$.value.direction : undefined;
  };

  useEffect(() => {
    if (selectedTableItems.length === filteredData$.value.length) {
      setIsChecked(true);
    } else {
      setIsChecked(false);
    }
  }, [selectedTableItems.length, filteredData$.value.length]);

  function handleCheckbox() {
    const newState = isChecked ? [] : filteredData$.value;
    dispatch(
      campaignReportsActions.updateProperty({
        propField: 'selectedTableItems',
        newValue: newState,
      }),
    );
  }

  const changeRequestType = (newRequestType) => {
    if (currentRequestType !== newRequestType) {
      originalTableData$.value = null;
      dispatch(
        campaignReportsActions.updateProperty({
          propField: 'tableRequestTypes',
          newValue: newRequestType,
        }),
      );
    }
    dropDownIsOpen1$.value = false;

    if (sortConfig$.value?.key === currentRequestType) {
      sortConfig$.value.key = newRequestType;
    }
  };

  const openClosePopUpButton = () => {
    dropDownIsOpen1$.value = !dropDownIsOpen1$.value;
  };

  return (
    <S.Box>
      <S.CheckboxWrap isBorder={isPressedBulkBtn}>
        {isPressedBulkBtn && (
          <CheckboxInner
            name={'checkbox-grouping'}
            isChecked={isChecked}
            id={'checkbox-grouping'}
            onChange={handleCheckbox}
          />
        )}
      </S.CheckboxWrap>
      <S.Text>Grouping:</S.Text>
      {isPressedBulkBtn ? (
        <S.DisabledText> {swappedObjTypes[currentRequestType]}</S.DisabledText>
      ) : (
        <S.GroupingBox ref={containerRef}>
          <S.ChooseRequest
            isOpen={dropDownIsOpen1$.value}
            onClick={openClosePopUpButton}
            style={{
              zIndex: 3000,
              cursor: 'pointer',
              position: 'relative',
            }}
          >
            {swappedObjTypes[currentRequestType]} <ArrowDropDown />
          </S.ChooseRequest>
          <DropDownWrapper
            isOpen$={dropDownIsOpen1$}
            width={140}
            targetRef={containerRef}
            style={{
              zIndex: 3000,
              top: '45px',
              left: '0px',
            }}
            outSideClickAction={() => {
              dropDownIsOpen1$.value = false;
            }}
          >
            <Each
              of={Object.entries(campaignReportsRequestTypes)}
              render={([key, value], index) => {
                return (
                  <MenuItem
                    isSelected={currentRequestType === value}
                    height={40}
                    value={value}
                    key={value}
                    onClick={changeRequestType}
                    style={{ marginBottom: '2px' }}
                  >
                    <ParagraphWithTooltip
                      text={key}
                      style={{ fontSize: '14px', fontWeight: '400' }}
                    />
                  </MenuItem>
                );
              }}
            />
          </DropDownWrapper>
        </S.GroupingBox>
      )}
      <S.ArrowIcon
        direction={getClassNamesFor(currentRequestType)}
        onClick={() => requestSort(currentRequestType)}
      >
        <ArrowDropDown />
      </S.ArrowIcon>
    </S.Box>
  );
};
